/**
 * Price — signature notification chime.
 *
 * Synthesized on the fly via the Web Audio API so we don't ship any
 * binary audio asset. Plays a friendly two-note "ding-doong" (E5 → G5)
 * with a soft envelope, ~450 ms total. Used:
 *  - In the admin "Test sound" button
 *  - By the push listener when an incoming notification has
 *    `data.sound === "price"`
 *
 * Fails silently on browsers without Web Audio support.
 */
export function playPriceChime() {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    const ctx = new AC();
    const now = ctx.currentTime;

    const master = ctx.createGain();
    master.gain.value = 0.28;
    master.connect(ctx.destination);

    const notes = [
      { freq: 659.25, start: 0.0,  dur: 0.28 }, // E5
      { freq: 783.99, start: 0.16, dur: 0.35 }, // G5
    ];

    for (const n of notes) {
      const osc = ctx.createOscillator();
      osc.type = "sine";
      osc.frequency.setValueAtTime(n.freq, now + n.start);

      const g = ctx.createGain();
      g.gain.setValueAtTime(0, now + n.start);
      g.gain.linearRampToValueAtTime(1, now + n.start + 0.02);
      g.gain.exponentialRampToValueAtTime(0.001, now + n.start + n.dur);

      osc.connect(g).connect(master);
      osc.start(now + n.start);
      osc.stop(now + n.start + n.dur + 0.05);
    }

    // Close the context after the sound plays so we don't leak.
    setTimeout(() => {
      try { ctx.close(); } catch (_e) { /* noop */ }
    }, 800);
  } catch (_e) {
    // Web Audio not available or blocked by autoplay policy — silent fallback.
  }
}
